import { render, staticRenderFns } from "./WaitingForMoneyPage.vue?vue&type=template&id=ebffb13a&scoped=true"
import script from "./WaitingForMoneyPage.vue?vue&type=script&lang=js"
export * from "./WaitingForMoneyPage.vue?vue&type=script&lang=js"
import style0 from "./WaitingForMoneyPage.vue?vue&type=style&index=0&id=ebffb13a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebffb13a",
  null
  
)

export default component.exports